import React, { useEffect, useRef, useState } from "react";
import DynamicForm from "./DynamicForm";
import { businessFileds, buyerFields } from "./formFields";
import { deleteFile, uploadFile } from "@/api/placeOffer";
import { ShimmerText } from "react-shimmer-effects";
import { BsCheckCircleFill } from "react-icons/bs";
import { validateAddress } from "@/api/bid";

const Buyer = ({
  setCifFormDetails,
  cifFormetails,
  setAccordionState,
  accordionState,
  profileDetails,
  llc,
  listingId,
  buyerAgent,
  pof,
  validateEmail,
  cifId
}) => {
  const [purchaseforIndividual, setPurchaseForIndividual] = useState("true");
  const [cobuyer, setCobuyer] = useState("false");
  const [isCoBuyerBusiness, setIsCoBuyerBusiness] = useState("false");
  const [buyer, setBuyer] = useState({});
  const [cobuyerDetails, setCobuyerDetails] = useState({});
  const [haveErrors, setHaveErrors] = useState(false);
  const [documentLoading,setDocumentLoading] = useState(false);
const [externalFormErrors, setExternalFormErrors] = useState({});
const [externalFormErrorsCo, setExternalFormErrorsCo] = useState({});
  const [fileErrors, setFileErrors] = useState({
    "llc-upload": "",
    "co-buyer": "",
  });
  const [uploadedFiles, setUploadedFiles] = useState({
    businessEntityDocs: [],
    coBuyerBusinessDocs: [],
  });
  const validationFnRef = useRef({
     buyer: null,
  coBuyer: null,
  });
  const [loading,setLoading] = useState(false);
  const ACCEPTED_FILE_TYPES =  [
  "application/pdf",
  "image/jpeg",
  "image/jpg"
];
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

const handleFileUpload = async (event, fileType) => {
  setDocumentLoading(true);
  const file = event.target.files[0];
  const fieldName = event.target.name;

  setFileErrors((prev) => ({ ...prev, [fieldName]: "" }));

  if (!file) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: "Please select a file.",
    }));
    setDocumentLoading(false);
    return;
  }

  const isValidType = ACCEPTED_FILE_TYPES.includes(file.type);
  const isValidSize = file.size <= MAX_FILE_SIZE;

  if (!isValidType) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: `Please upload document in pdf, jpg or jpeg format.`,
    }));
    setDocumentLoading(false);
    return;
  }

  if (!isValidSize) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: "Maximum file size allowed is 10MB.",
    }));
    setDocumentLoading(false);
    return;
  }

  try {
    const formData = new FormData();
    const data = {
      listingId,
      fileCategory: "LLC",
      fileSubCategory:
        fileType === "businessEntityDocs" ? "LLC-buyer" : "LLC-cobuyer",
      cifId,
    };

    formData.append("file", file);
    formData.append(
      "fileUploadRequest",
      new Blob([JSON.stringify(data)], {
        type: "application/json",
      })
    );

    const response = await uploadFile(formData);

    if (response?.data?.data) {
      setUploadedFiles((prev) => ({
        ...prev,
        [fileType]: [...(prev[fileType] || []), response.data.data],
      }));

      setFileErrors((prev) => ({
        ...prev,
        [fieldName]: "",
      }));
    } else {
      throw new Error("No data returned from upload API.");
    }
  } catch (error) {
    console.error("Upload failed:", error);
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: error?.message || "Error uploading file.",
    }));
  } finally {
    event.target.value = ""; // reset file input
    setDocumentLoading(false);
  }
};


 
  const checkStateCityZip = async (address1, city, stateId, zip,type) => {
    try {
      setLoading(true)
      const payload = {
        address1: address1,
        city: city,
        state: stateId,
        zip: zip,
      };
      const data = await validateAddress(payload);
      if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
        // setInvalidCombination(true);
        setLoading(false)
        if(type==="buyer"){
          setExternalFormErrors((prev) => ({
            ...prev,
            zip: "Provided zip code is not valid for selected state",
          }));
          

        }else{
           setExternalFormErrorsCo((prev) => ({
            ...prev,
            zip: "Provided zip code is not valid for selected state",
          }));
        }
        // setLoading(false)
        setHaveErrors(true);
         return { hasError: true };
      } else {
        if(type==="buyer"){
          setLoading(false)
          setExternalFormErrors((prev) => {
            const { zip, ...rest } = prev;
            return rest;
          });
        }else{
            setExternalFormErrorsCo((prev) => {
            const { zip, ...rest } = prev;
            return rest;
          });
        }
        //  setLoading(false)
          return { hasError: false };
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
      //  setLoading(false)
    }
  };
  const submitData = async() => {
    setLoading(true)
  const buyerValidation = validationFnRef.current.buyer?.();
  const coBuyerValidation = cobuyer === "true"
    ? validationFnRef.current.coBuyer?.()
    : { isValid: true, errors: {} }; 

  const allErrors = {
    ...buyerValidation?.errors,
    ...coBuyerValidation?.errors,
  };
  if (
    uploadedFiles.businessEntityDocs?.length === 0 &&
    llc === "Required" &&
    purchaseforIndividual === "false"
  ) {
    setFileErrors((prev) => ({
      ...prev,
      "llc-upload": "Please upload at least one LLC document to proceed.",
    }));
    setLoading(false)
    return;
  }

  if (
    cobuyer === "true" &&
    isCoBuyerBusiness === "true" &&
    uploadedFiles.coBuyerBusinessDocs?.length === 0 &&
    llc === "Required"
  ) {
    setFileErrors((prev) => ({
      ...prev,
      "co-buyerllc": "Please upload at least one LLC document to proceed.",
    }));
    setLoading(false)
    return;
  }

  const allValid =
    (buyerValidation?.isValid ?? true) &&
    (coBuyerValidation?.isValid ?? true);

  if (!allValid) {
    setLoading(false)
    return; 
  }
    
 const add = await checkStateCityZip(
      buyer?.address1,
      buyer?.city,
      buyer?.stateId,
      buyer?.zip,
      "buyer"
    );
    if(add.hasError){
setLoading(false)

      return
    }
    if (cobuyer === "true") {
     const coadd =  await checkStateCityZip(
        cobuyerDetails?.address1,
        cobuyerDetails?.city,
        cobuyerDetails?.stateId,
        cobuyerDetails?.zip,
        "cobuyer"
      );
      if(coadd?.hasError){
      setLoading(false)

        return
      }
    }
setLoading(false)
  setCifFormDetails({
    ...cifFormetails,
    buyer: buyer,
    coBuyer: cobuyerDetails,
  });

   const findNextAccordion = () => {
      if (buyerAgent) {
        setAccordionState({
          ...accordionState,
          accordion2:{
            ...accordionState.accordion2,close:true,edit:true,visited:true
          },
          accordion3: {
            ...accordionState.accordion3,
            close: false,
            edit:false
          },
        });
      } else {
        if(pof === "Optional" || pof === "Required"){
          setAccordionState({
            ...accordionState,
            accordion2:{
              ...accordionState.accordion2,close:true,edit:true,visited:true
            },
            accordion4: {
              ...accordionState.accordion4,
              close: false,
              edit:false,
              visited:false
            },
          });
        }else{
          setAccordionState({
          ...accordionState,
          accordion2:{
            ...accordionState.accordion2,close:true,edit:true,visited:true
          },
          accordion5: {
            ...accordionState.accordion5,
            close: false,
            edit:false,
            visited:false
          },
        });
        }
      }
    };
  findNextAccordion();
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "cobuyer") {
      setCobuyer(value);
    } else if (name === "cobuyerBusiness") {
      setIsCoBuyerBusiness(value);
    } else {
      setPurchaseForIndividual(value);
    }
  };

useEffect(() => {
  // Only run if profileDetails is valid
  if (!profileDetails || !profileDetails.userDetails) return;

  setBuyer((prev) => {
    const safe = (existing, fromProfile) =>
      existing && existing !== "" ? existing : fromProfile || "";

    // For userRole === "Buyer", always prefill
    if (cifFormetails?.userRole === "Buyer") {
      return {
        ...prev,
        firstName: safe(prev.firstName, profileDetails.userDetails.firstName),
        lastName: safe(prev.lastName, profileDetails.userDetails.lastName),
        middleInitials: safe(prev.middleInitials, profileDetails.userDetails.middleInitials),
        email: safe(prev.email, profileDetails.userDetails.emailId),
        phone: safe(prev.phone,""),
        address1: safe(prev.address1, profileDetails.userDetails.address?.address1),
        address2: safe(prev.address2, profileDetails.userDetails.address?.address2),
        stateId: safe(prev.stateId, profileDetails.userDetails.address?.state),
        city: safe(prev.city, profileDetails.userDetails.address?.city),
        zip: safe(prev.zip, profileDetails.userDetails.address?.zip),
      };
    }

    // For userRole === "Agent"
    if (cifFormetails?.userRole === "Agent") {
      // If agent is buying for themselves (buyerAgent is false), prefill
      if (!buyerAgent) {
        return {
          ...prev,
          firstName: safe(prev.firstName, profileDetails.userDetails.firstName),
          lastName: safe(prev.lastName, profileDetails.userDetails.lastName),
          middleInitials: safe(prev.middleInitials, profileDetails.userDetails.middleInitials),
          email: safe(prev.email, profileDetails.userDetails.emailId),
          phone: safe(prev.phone, ""),
          address1: safe(prev.address1, profileDetails.userDetails.address?.address1),
          address2: safe(prev.address2, profileDetails.userDetails.address?.address2),
          stateId: safe(prev.stateId, profileDetails.userDetails.address?.state),
          city: safe(prev.city, profileDetails.userDetails.address?.city),
          zip: safe(prev.zip, profileDetails.userDetails.address?.zip),
        };
      }

      // If agent is not buying for themselves (i.e. buyerAgent is true), clear the fields
      return {
        ...prev,
        firstName: "",
        lastName: "",
        middleInitials: "",
        email: "",
        phone: "",
        address1: "",
        address2: "",
        stateId: "",
        city: "",
        zip: "",
      };
    }

    return prev; // fallback
  });
  // Optional: safeguard cobuyer defaults
  setCobuyerDetails((prev) => ({
    ...prev,
    firstName: prev.firstName || "",
    lastName: prev.lastName || "",
    middleInitials: prev.middleInitials || "",
    email: prev.email || "",
    phone: prev.phone || "",
    address1: prev.address1 || "",
    address2: prev.address2 || "",
    stateId: prev.stateId || "",
    city: prev.city || "",
    zip: prev.zip || "",
  }));
}, [buyerAgent, profileDetails, cifFormetails?.userRole]);

useEffect(() => {
  setBuyer((prev) => ({
    ...prev,
    purchaseFor: purchaseforIndividual === "true" ? "INDIVIDUAL" : "BUSINESS",
  }));
}, [purchaseforIndividual]);

useEffect(() => {
  setCobuyerDetails((prev) => ({
    ...prev,
    purchaseFor: isCoBuyerBusiness === "false" ? "INDIVIDUAL" : "BUSINESS",
  }));
}, [isCoBuyerBusiness]);

  const handleFileDelete = async (fileType, fileId) => {
    try {
      setDocumentLoading(true)
      const data = await deleteFile({ fileId, listingId });
      if (data?.data?.status === "SUCCESS") {
        setBuyer((prevState) => {
          const newState = { ...prevState };
          delete newState[fileType];
          return newState;
        });
         setDocumentLoading(false)

        setUploadedFiles((prev) => ({
          ...prev,
          [fileType]: prev[fileType].filter(
            (file) => file.documentId !== fileId
          ),
        }));

        setFileErrors((prev) => ({
          ...prev,
          [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
            "",
        }));
      } else {
         setDocumentLoading(false)
        setFileErrors((prev) => ({
          ...prev,
          [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
            "Error deleting file",
        }));
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setFileErrors((prev) => ({
        ...prev,
        [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
          "Error deleting file",
      }));
       setDocumentLoading(false)
    }
  };
  

  const handleFileDownload = async (documentId, fileName) => {
    try {
      const response = await fetch(
        `/portal/postcontract/download/${documentId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("File not found or access denied"); 
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  
  return (
    <>
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header  p-1" id="flush-headingTwo">
        <div
          className={`accordion-button ${
            accordionState?.accordion2?.close ? "collapsed" : ""
          }  ${
            accordionState?.accordion2?.close &&
            accordionState?.accordion2?.visited
              ? "no-caret"
              : ""
          }`}
          // type="button"
          // data-bs-toggle="collapse"
          // data-bs-target="#flush-collapseTwo"
          // aria-expanded="false"
          id="acc2"
          // aria-controls="flush-collapseTwo"
          disabled={accordionState?.accordion2?.close}
        >
          <div className="d-flex justify-content-between w-100">
                     <p className="mb-0 responsive-heading">
                       {(accordionState?.accordion2?.visited )? (
                         <BsCheckCircleFill className="icon_bid me-2" size={30} />
                       ) : (
                         <BsCheckCircleFill className="text-dark me-2" size={30} />
                       )}
                       Buyer
                     </p>
                     {accordionState?.accordion2?.edit && (
                       <>
                         <div>
                           <span
                             className="fa fa-pencil cursor-pointer"
                             onClick={() =>{
                              if(buyerAgent){
                                setAccordionState({
                                  ...accordionState,
                                   accordion1:{
                            ...accordionState.accordion1,
                            close: true,
                            visited: true,
                            edit: true,
                          },
                                  accordion2: {
                                    ...accordionState.accordion2,
                                    edit: false,
                                    close: false,
                                    visited: false,
                                  },
                                  accordion3: {
                                    ...accordionState.accordion3,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                   accordion4: {
                                    ...accordionState.accordion4,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                   accordion5: {
                                    ...accordionState.accordion5,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                })
                              }else{
                                if(pof === "Optional" || pof === "Required"){
                                  setAccordionState({
                                    ...accordionState,
                                    accordion2: {
                                      ...accordionState.accordion2,
                                      edit: false,
                                      close: false,
                                      visited: false,
                                    },
                                     accordion3: {
                                    ...accordionState.accordion3,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                    accordion4: {
                                      ...accordionState.accordion4,
                                      close: true,
                                      visited: false,
                                      edit:true
                                    },
                                     accordion5: {
                                    ...accordionState.accordion5,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                  })
                                }else{
                                  setAccordionState({
                                    ...accordionState,
                                    accordion2: {
                                      ...accordionState.accordion2,
                                      edit: false,
                                      close: false,
                                      visited: false,
                                    },
                                      accordion3: {
                                    ...accordionState.accordion3,
                                    close: true,
                                    visited: false,
                                    edit:true
                                  },
                                    accordion5: {
                                      ...accordionState.accordion5,
                                      close: true,
                                      visited: false,
                                      edit:true
                                    },
                                  })
                                }
                               
                              }
                             }
                            }
                           ></span>
                         </div>
                       </>
                     )}
                   </div>
        </div>
      </h2>
        {
          accordionState?.accordion2?.edit?
          <>
            <div className="container px-3 px-sm-2">
              <p className="edit-buyer-text">
                Buyer's information on legal document will be:
              </p>
              <div className="row">
                <div className="col-6">
                   <p className="edit-buyer-data">Buyer :-</p>
                   {
                    buyer?.company && 
                <p className="edit-buyer-data">{buyer?.company}</p>
                   }

                <p className="edit-buyer-data mb-0">{buyer?.firstName}{" "}{buyer?.lastName}</p>
                <p className="edit-buyer-data">{buyer?.email}</p>
                </div>
                {
                  (cobuyerDetails?.firstName || cobuyerDetails?.lastName || cobuyerDetails?.email ) &&
                <div className="col-6">
                  <p className="edit-buyer-data">Co-Buyer :-</p>
                   {
                    cobuyerDetails?.company && 
                <p className="edit-buyer-data">{cobuyerDetails?.company}</p>
                   }
                <p className="edit-buyer-data mb-0">{cobuyerDetails?.firstName}{" "}{cobuyerDetails?.lastName}</p>
                <p className="edit-buyer-data">{cobuyerDetails?.email}</p>
                </div>
                }
              </div>
              
            </div>
          </>:
        
      <div
        id="flush-collapseTwo"
        className={`accordion-collapse collapse ${
          accordionState?.accordion2?.close ? "" : "show"
        }`}
        aria-labelledby="flush-headingTwo"
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body mobile-padding-0-offer">
          <div className="purchasefor">
            <p className="mb-0 pt-1 purchase-for-ui">
            The purchase is being made on behalf of:
            </p>
            <div className="values">
              <div className="form-check form-check-inline fs-12">
                <input
                  className="form-check-input"
                  type="radio"
                  name="purchaseOnBehalfIndividual"
                  id="purchaseforIndividual"
                  value="true"
                  checked={purchaseforIndividual === "true" ? true : false}
                  onChange={handleChange}
                />
                <label
                  className="form-check-label mt-1"
                  htmlFor="purchaseforIndividual"
                >
                  Individual
                </label>
              </div>
              <div className="form-check form-check-inline fs-12">
                <input
                  className="form-check-input"
                  type="radio"
                  name="purchaseOnBehalfIndividual"
                  id="purchaseforBusiness"
                  value="false"
                  onChange={handleChange}
                  checked={purchaseforIndividual === "false" ? true : false}
                />
                <label
                  className="form-check-label mt-1"
                  htmlFor="purchaseforBusiness"
                >
                  Business
                </label>
              </div>
            </div>
          </div>
          <div className="buyer-form">
            {purchaseforIndividual === "true" ? (
              <DynamicForm
                fieldsConfig={buyerFields}
                setCifFormDetails={setBuyer}
                cifFormetails={buyer}
                // preFilledEmail={
                //   profileDetails?.userDetails?.emailId ? true : false
                // }
                preFilledEmail={false}
                setHaveErrors={setHaveErrors}
                statePrefilled={null}
                registerValidationTrigger={(fn) =>
                  (validationFnRef.current.buyer = fn)
                }
                validateAgentEmail={validateEmail}
                externalErrors={externalFormErrors}
                setExternalFormErrors={setExternalFormErrors}

              />
            ) : (
              <>
                <DynamicForm 
                  fieldsConfig={businessFileds}
                  setCifFormDetails={setBuyer}
                  cifFormetails={buyer}
                  // preFilledEmail={
                  //   profileDetails?.userDetails?.emailId ? true : false
                  // }
                   preFilledEmail={false}
                  setHaveErrors={setHaveErrors}
                  statePrefilled={null}
                  validateAgentEmail={validateEmail}
                  registerValidationTrigger={(fn) =>
                    (validationFnRef.current.buyer = fn)
                  }
                  externalErrors={externalFormErrors}
                  setExternalFormErrors={setExternalFormErrors}

                />
                {(llc === "Required" || llc === "Optional") && (
                  <div className="upload-document-section mt-3">
                    <p className="fs-12">
                      Please upload Business Entity formation documents here
                      (E.g.: LLC - Certificate of Formation, Corporation -
                      Articles of Incorporation, LP - Certificate of Limited
                      Partnership, etc.){" "}
                      {llc === "Required" && (
                        <span className="mandatory"> *</span>
                      )}
                    </p>
                    <>
                      <input
                        type="file"
                        name="llc-upload"
                        id="llc-upload"
                        required={llc === "Required"}
                        onChange={(e) =>
                          handleFileUpload(e, "businessEntityDocs")
                        }
                        accept=".pdf,.jpg,.jpeg"
                        // className="form-control m-3 w-50"
                        className="d-none"
                      />
                      <label htmlFor="llc-upload" className="llc-upload-btn">
                        Upload Business Entity Formation Documents
                      </label>
                      <div className="cursor-pointer d-inline-block mb-0 info-tooltip-offer" data-toggle="tooltip" data-placement="top" title="If a legal entity is purchasing the property, please upload the formation documents for that entity stamped as filed with the relevant state agency (typically the office of the Secretary of State where the entity was formed). Examples of acceptable documents include stamped copies of: the Articles of Incorporation of a corporation, Certificate of Formation for a LLC, Certificate of Limited Partnership for a LP.">
                       i</div>
                    </>
                     <p className="info-uploaf">File formats accepted: pdf, jpg and jpeg. Maximum file size allowed is 10MB.
</p>
                    {
                      documentLoading && <ShimmerText line={2} gap={10} className="mt-2" />
                    }
                    {uploadedFiles.businessEntityDocs?.length > 0 && (
                      <>
                        {uploadedFiles?.businessEntityDocs?.map((data) => (
                          <>
                            <div className="uploaded-file-container p-2">
                              <div className="file-info d-flex align-items-center">
                                <img
                                src="/assets/images/downloadIconOffer.png"
                                height={"14px"} width={"14px"}
                                  className=""
                                  onClick={() =>
                                    handleFileDownload(
                                      data?.documentId,
                                      data?.fileName
                                    )
                                  }
                                />
                                <span className="fs-12 filename-offer">{data?.fileName}</span>
                                <button
                                  className="btn-delete-offer-file"
                                  onClick={() =>
                                    handleFileDelete(
                                      "businessEntityDocs",
                                      data?.documentId
                                    )
                                  }
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </>
                        ))}
                      </>
                    )}
                    {fileErrors["llc-upload"]?.length>0 && (
                      <div
                        className={`error-message-offer `}
                      >
                        {fileErrors["llc-upload"]}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            <div className="co-buyer p-3">
              <div className="cobuyer-selection">
                <div className="d-flex g-5 justify-content-start">
                  <p className="purchase-for-ui  mb-4 pt-1 mr90 ">
                    Do you have a co-buyer?
                  </p>
                  <div className="values">
                    <div className="form-check form-check-inline fs-12">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cobuyer"
                        id="cobuyer-yes"
                        value="true"
                        onChange={handleChange}
                        checked={cobuyer === "true" ? true : false}
                      />
                      <label className="form-check-label" htmlFor="cobuyer-yes">
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline fs-12">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cobuyer"
                        id="cobuyer-no"
                        value="false"
                        onChange={handleChange}
                        checked={cobuyer === "false" ? true : false}
                      />
                      <label className="form-check-label" htmlFor="cobuyer-no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
                {cobuyer === "true" && (
                  <>
                    <div className="d-flex fs-12 flex-wrap">
                      <p className="purchase-for-ui  mb-4 pt-1 mr41">
                        Is the co-buyer a business entity?
                      </p>
                      <div className="values">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="cobuyerBusiness"
                            id="cobuyer-yes-be"
                            value="true"
                            onChange={handleChange}
                            checked={
                              isCoBuyerBusiness === "true" ? true : false
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cobuyer-yes-be"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="cobuyerBusiness"
                            id="cobuyer-no-be"
                            value="false"
                            onChange={handleChange}
                            checked={
                              isCoBuyerBusiness === "false" ? true : false
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cobuyer-no-be"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    {isCoBuyerBusiness === "false" ? (
                      <DynamicForm
                        fieldsConfig={buyerFields}
                        setCifFormDetails={setCobuyerDetails}
                        cifFormetails={cobuyerDetails}
                        setHaveErrors={setHaveErrors}
                        preFilledEmail={false}
                        statePrefilled={null}
                        registerValidationTrigger={(fn) =>
                          (validationFnRef.current.coBuyer = fn)
                        }
                        externalErrors={externalFormErrorsCo}
                        setExternalFormErrors={setExternalFormErrorsCo}

                      />
                    ) : (
                      <>
                
                        <DynamicForm
                          fieldsConfig={businessFileds}
                          setCifFormDetails={setCobuyerDetails}
                          cifFormetails={cobuyerDetails}
                          setHaveErrors={setHaveErrors}
                          preFilledEmail={false}
                          statePrefilled={null}
                          registerValidationTrigger={(fn) =>
                            (validationFnRef.current.coBuyer = fn)
                          }
                           externalErrors={externalFormErrorsCo}
                        setExternalFormErrors={setExternalFormErrorsCo}

                        />
                        {(llc === "Required" || llc === "Optional") && (
                          <div className="upload-document-section mt-3">
                            <p className="fs-12">
                              Please upload Business Entity formation documents
                              here (E.g.: LLC - Certificate of Formation,
                              Corporation - Articles of Incorporation, LP -
                              Certificate of Limited Partnership, etc.)
                            </p>
                            {/* {!uploadedFiles.coBuyerBusinessDocs ? ( */}
                              <>
                              <input
                                type="file"
                                name="co-buyerllc"
                                id="co-buyerllc"
                                required={llc === "Required" ? true : false}
                                onChange={(e) =>
                                  handleFileUpload(e, "coBuyerBusinessDocs")
                                }
                                accept=".pdf,.jpg,.jpeg"
                                // className="form-control"
                                className="d-none"
                              />
                               <label htmlFor="co-buyerllc" className="llc-upload-btn">
                        Upload Business Entity Formation Documents
                      </label>
                       <div className="cursor-pointer d-inline-block mb-0 info-tooltip-offer" data-toggle="tooltip" data-placement="top" title="If a legal entity is purchasing the property, please upload the formation documents for that entity stamped as filed with the relevant state agency (typically the office of the Secretary of State where the entity was formed). Examples of acceptable documents include stamped copies of: the Articles of Incorporation of a corporation, Certificate of Formation for a LLC, Certificate of Limited Partnership for a LP.">
                       i</div>
                      </>
                      <p className="info-uploaf">File formats accepted: pdf, jpg and jpeg. Maximum file size allowed is 10MB.
</p>
                            {/* ) : (
                              <div className="uploaded-file-container p-2">
                                <div className="file-info">
                                  <span className="p-3">
                                    File :{" "}
                                    {uploadedFiles.coBuyerBusinessDocs.fileName}
                                  </span>
                                </div>
                                <div className="m-3">
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      handleFileDownload(
                                        uploadedFiles.coBuyerBusinessDocs
                                          .fileUrl,
                                        uploadedFiles.coBuyerBusinessDocs
                                          .fileName
                                      )
                                    }
                                  >
                                    Download
                                  </button>
                                  <button
                                    className="btn btn-thm mx-3"
                                    onClick={() =>
                                      handleFileDelete(
                                        "coBuyerBusinessDocs",
                                        uploadedFiles.coBuyerBusinessDocs.fileId
                                      )
                                    }
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            )} */}
 {
                      documentLoading && <ShimmerText line={2} gap={10} className="mt-2" />
                    }
                    {uploadedFiles.coBuyerBusinessDocs?.length > 0 && (
                      <>
                        {uploadedFiles?.coBuyerBusinessDocs?.map((data) => (
                          <>
                            <div className="uploaded-file-container p-2">
                              <div className="file-info d-flex align-items-center">
                                <img
                                src="/assets/images/downloadIconOffer.png"
                                height={"14px"} width={"14px"}
                                  className=""
                                  onClick={() =>
                                    handleFileDownload(
                                      data?.documentId,
                                      data?.fileName
                                    )
                                  }
                                />
                                <span className="fs-12 filename-offer">{data?.fileName}</span>
                                <button
                                  className="btn-delete-offer-file"
                                  onClick={() =>
                                    handleFileDelete(
                                      "coBuyerBusinessDocs",
                                      data?.documentId
                                    )
                                  }
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </>
                        ))}
                      </>
                    )}
                    
                    {fileErrors["co-buyerllc"] && (
                      <div
                        className={`error-message-offer `}
                      >
                        {fileErrors["co-buyerllc"]}
                      </div>
                    )}
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="continue-button mt-3 ml10"
            onClick={submitData}
          >
            {
              loading?"Continue...":"Continue"
            }
          </button>
        </div>
      </div>
      }
      {/* disabled={haveErrors || (llc === "Required" && uploadedFiles?.businessEntityDocs?.fileUrl)} */}
    </div>
    </>
  );
};

export default Buyer;
